import { createContext, useContext } from 'react';
import type { BetaNavItemKey } from './SecondaryNav';

type BetaSecondaryNavItemContextValue = {
  /** The unique ID of the `BetaSecondaryNavItem` */
  itemId: BetaNavItemKey;
  /** The unique ID of the `BetaSecondaryNavList` inside of a `BetaSecondaryNavItem`. */
  listId: string;
};

export const BetaSecondaryNavItemContext = createContext<
  BetaSecondaryNavItemContextValue | undefined
>(undefined);

/**
 * Context to share the unique IDs of the `BetaSecondaryNavItem` and `BetaSecondaryNavList`.
 */
export const useSecondaryNavItemContext = () => {
  return useContext(BetaSecondaryNavItemContext);
};
